import React, { useContext, useState ,useEffect, useRef } from "react";
import { LanguageContext } from '../../context'
import './Languageselector.css'
import { useParams, useNavigate } from 'react-router-dom';
import Translate from "../Translate/Translate";
import deleteIcon from "../../Images/Header/delete.svg"

const LanguageSelector = () => {

  const {switchLang,language}=useContext(LanguageContext);
  const [active,setActive]=useState(false);
  const {langParam}=useParams();
  const refClose=useRef(null);
  const refMenu=useRef(null);
  const hasMenuChanged=useRef(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!hasMenuChanged.current) {
      return;
    }

    if (active) {
      refClose.current?.focus();
      return;
    }

    refMenu.current?.focus();
  }, [active]);



  const changeLanguage=(event)=>{
    var currentPath=window.location.pathname.replace(`/${language}`,"");
    //currentPath=currentPath.substring(currentPath.indexOf('/'))
    navigate(`/${event.target.title.toLocaleLowerCase()}${currentPath}${window.location.search}`)

    switchLang(event.target.title.toLocaleLowerCase());
    closeLang();
    return false;
  }
  const openLang=()=>{
    hasMenuChanged.current=true;
    setActive(true);
    return false;
  }

  const closeLang=()=>{
    hasMenuChanged.current=true;
    setActive(false);
    return false;
  }

  const handleClose=()=>{
    refClose.current?.focus();
  }

  const handleMenuKeyDown=(event)=>{
    if(event.key==='Escape'){
      closeLang();
    }
  }

  const getLang=()=>{
    if(language.toLocaleLowerCase()==="he")
      return "עברית";
    if(language.toLocaleLowerCase()==="en")
      return "English";
  }

  useEffect(()=>{
    if(langParam !== undefined ){
      if(langParam!=="he" && langParam!=="en"){
        navigate("/404page");
      }
      else if(language!==langParam){
        switchLang(langParam);
      }
    } 
  },[langParam, language, navigate, switchLang]);

  return (

    <div className="lang-container">
      <button type="button" className="current-lang" onClick={openLang} ref={refMenu} aria-haspopup="true" aria-expanded={active}>
        <span className={`arrow ${active ? 'open' : 'close'}`} ></span>
        <span className="lang-txt" aria-label={getLang()}>{language.toLocaleUpperCase()}</span>
      </button>

      <ul className={active?'select-lang active':'select-lang'} aria-label="תפריט שפות" onKeyDown={handleMenuKeyDown}>
        <li><button type="button" className="close-button" aria-label="סגור תפריט שפות" ref={refClose} onClick={closeLang}>
                <img src={deleteIcon} alt="" /></button></li>
        <li className="lang" ><input type="button"  value="עברית" title="He"   onClick={changeLanguage}></input> </li>
        <li className="lang" ><input type="button"  value="English" title="En" onClick={changeLanguage} ></input> </li>
        <li className='offset lastDivClose' tabIndex="0" onBeforeInput={handleClose} onFocus={handleClose}><Translate>MustCloseSection</Translate></li>
      </ul>
    </div>
  );

};


export default LanguageSelector;